import React, { useState } from 'react';
import PropTypes from 'prop-types';

const Context = React.createContext({});

export function TabStripContextProvider({ children }) {
  const [registrationError, setRegistrationError] = useState(null);

  return (
    <Context.Provider value={{
      registrationError,
      setRegistrationError,
    }}
    >
      {children}
    </Context.Provider>
  );
}

TabStripContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.node,
  ]),
};

export default Context;
